<template>
    <div
        class="dashboard-board-menu noselect"
        :class="{'dashboard-board-menu_menu-collapsed': isMenuCollapsed}"
    >
        <draggable
            handle=".dashboard-board-menu-board"
            :list="boardsNames"
            @change="swapBoards"
            @unchoose="unchooseBoard"
            class="dashboard-board-menu-draggable"
            :disabled="isDisableDraggable"
        >
            <div
                class="dashboard-board-menu-board"
                v-for="(boardName,boardNameIndex) in boardsNames"
                :key="boardNameIndex"
                :style="{width:boardWidth}"
                :class="{'dashboard-board-menu-board_active' :boardNameIndex === activeBoardIndex}"
                @mouseover="showTooltip($event,'boardMenuTooltip',boardName)"
                @mousedown.self="changeBoard(boardNameIndex)"
                @touchstart.self="changeBoard(boardNameIndex)"
            >
                <template v-if="boardNameIndex === activeBoardIndex">
                    <div
                        class="dashboard-board-menu-board__apply-name"
                        v-if="isAllowEditName && isEditMode"
                        @click.stop="applyName(boardName)"
                    >
                        <div class="dashboard-board-menu-board__apply-name-icon"></div>
                    </div>
                    <div
                        class="dashboard-board-menu-board__edit-name"
                        v-else-if="!isAllowEditName && isEditMode"
                        @click.stop="allowEditBoardName(boardName)"
                    >
                        <div class="dashboard-board-menu-board__edit-name-icon"></div>
                    </div>
                </template>
                <template v-if="isAllowEditName && activeBoardIndex === boardNameIndex">
                    <div
                        @click.stop.capture=""
                        v-on:keyup.enter="applyName(boardName)"
                        class="dashboard-board-menu-board-input"
                    >
                        <VInput v-model="newBoardName"></VInput>
                    </div>
                </template>
                <template v-else>
                    <div class="dashboard-board-menu-board-row">
                        <span class="dashboard-board-menu-board__text"> {{ boardName }}</span>
                    </div>
                    <div
                        v-if="boards.length > 1 && isEditMode"
                        @click="showNotification(boardNameIndex, boardName)"
                        class="dashboard-board-menu-board__delete"
                    >
                    </div>
                </template>
            </div>
        </draggable>
        <div
            class="dashboard-board-menu-add-board"
            v-if="isEditMode"
            @click="addBoard"
        >
            <div class="dashboard-board-menu-add-board-icon">

            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import apiBoards from '@/api/apiBoards';
    import {eventBus} from '@/main';
    import {isElementContainsClass} from '../../helpers/domHelper';
    import {ResizeObserver} from '@juggle/resize-observer';

    export default {
        name: 'BoardMenu',
        components: {
            draggable,
        },
        props: {
            boards: {
                type: Array,
                required: true,
            },
            activeBoardIndex: {
                type: Number,
                required: true,
                default: 0,
            },
            isMenuCollapsed: {
                type: Boolean,
                required: true,
            },
            isDisabled: {
                type: Boolean,
                required: true,
            },
            isEditMode: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                isAllowImport: false,
                isAllowEditName: false,
                stateInputText: '',
                newBoardName: '',
                boardWidth: '100px',
                isBoardDragged: false,
            };
        },
        watch: {
            boards: {
                deep: true,
                immediate: false,
                handler() {
                    this.getCountofBoards();
                },
            },
        },
        computed: {
            isDisableDraggable() {
                return this.isAllowEditName || this.isBoardsDisabled;
            },
            boardsNames() {
                return this.boards.map(({name}) => name);
            },
            isBoardsDisabled() {
                return this.isDisabled && !this.isBoardDragged;
            },
        },
        created() {
            eventBus.$on('VNotification-DeleteBoard', this.deleteBoard);
        },
        mounted() {
            this.initBoardMenuObserver();
        },
        beforeDestroy() {
            eventBus.$off('VNotification-DeleteBoard', this.deleteBoard);
        },
        methods: {
            initBoardMenuObserver() {
                new ResizeObserver(this.getCountofBoards).observe(document.querySelector('.dashboard-board-menu'));
            },
            getCountofBoards() {
                this.$nextTick(() => {
                    const boardsBlock = document.querySelector('.dashboard-board-menu');
                    if (boardsBlock) {
                        const boardsBlockWidth = boardsBlock.getBoundingClientRect().width;
                        this.boardWidth = `${boardsBlockWidth / this.boards.length}px`;
                    }
                });
            },
            addBoard(index) {
                if (!this.isDisabled) {
                    this.$emit('addBoard', index);
                }
            },
            showNotification(index, boardName) {
                    const notification = {};
                    notification.confirmText = 'Delete';
                    notification.data = index;
                    notification.eventConfirm = 'VNotification-DeleteBoard';
                    notification.contentText = 'All your settings for this board will be lost.';
                    notification.headerText = `Delete board ${boardName}?`;
                    eventBus.$emit('VNotificationShow', notification);
            },
            deleteBoard(index) {
                if (this.activeBoardIndex === index) {
                    this.isAllowEditName = false;
                }
                this.$emit('deleteBoard', index);
            },
            allowEditBoardName(boardName) {
                if (!this.isDisabled) {
                    this.isAllowEditName = true;
                    this.newBoardName = boardName;
                }
            },
            applyName(boardName) {
                if (!this.isDisabled && this.newBoardName.length) {
                    this.isAllowEditName = false;
                    if (boardName !== this.newBoardName) {
                        const boards = _.clone(this.boards);
                        boards[this.activeBoardIndex].name = this.newBoardName;
                        this.$emit('update:boards', Object.freeze(boards));
                        this.$emit('updateStateForBoards');
                    }
                }
            },
            changeBoard(index) {
                if (this.activeBoardIndex !== index) {
                    this.isBoardDragged = true;
                    this.isAllowEditName = false;
                    this.newBoardName = '';
                    this.$emit('changeActiveTab', index, this.activeBoardIndex);
                }
            },
            unchooseBoard() {
                this.isBoardDragged = false;
            },
            swapBoards(swapObj) {
                const boards = _.clone(this.boards);
                const movedBoard = boards.splice(swapObj.moved.oldIndex, 1)[0];
                boards.splice(swapObj.moved.newIndex, 0, movedBoard);
                this.$emit('update:boards', Object.freeze(boards));
                this.$emit('updateActiveBoardIndexAfterSwap');
                apiBoards.swapBoardsInBoardset(swapObj.moved.oldIndex, swapObj.moved.newIndex).then(() => {
                });
            },
            showTooltip(event, tooltipFunctionName, data) {
                const isRightElement = isElementContainsClass(event.target,
                    ['dashboard-board-menu-board', 'dashboard-board-menu-board-row', 'dashboard-board-menu-board__text']);
                if (isRightElement) {
                    this.$emit('showTooltip', event, tooltipFunctionName, data);
                }
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .dashboard {
        &-board-menu {
            display: flex;
            cursor: pointer;
            color: $primary-color;
            font-weight: bold;
            width: 100%;

            @include scrollbar-styles;


            &-draggable {
                display: flex;
                width: calc(100% + 20px);
            }

            &-board {
                height: 40px;
                border-radius: 5px 5px 0 0;
                display: flex;
                align-items: center;
                color: $primary-color;
                font-size: 12px;
                letter-spacing: 0;
                line-height: 15px;
                text-align: center;
                max-width: 180px;
                position: relative;

                &-row {
                    border-right: 1px solid $primary-color;
                    display: flex;
                    overflow: hidden;
                    position: relative;
                    width: 100%;
                    pointer-events: none;
                }

                &-input {
                    ::v-deep input {
                        width: calc(100% - 30px);
                    }
                }

                &__text {
                    max-width: calc(100% - 30px);
                    overflow: hidden;
                    white-space: nowrap;
                    margin-left: 10px;
                    pointer-events: none;
                    text-overflow: ellipsis;
                }

                &__delete {
                    position: absolute;
                    right: 10px;
                    width: 10px;
                    height: 18px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image: url('data:image/svg+xml;base64,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');

                    &:hover {
                        background-image: url('data:image/svg+xml;base64,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');
                    }
                }

                &:hover {
                    color: #000F48;

                    .dashboard-board-menu-board__delete {
                        background-image: url('data:image/svg+xml;base64,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');
                    }
                }

                &_active {
                    background: #fff;
                    color: #000F48;
                    margin-left: -1px;
                    position: relative;

                    .dashboard-board-menu-board__delete {
                        background-image: url('data:image/svg+xml;base64,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');
                    }

                    .dashboard-board-menu-board-row {
                        border-right: none;
                    }
                }

                &__apply-name {
                    margin-left: 10px;

                    &-icon {
                        width: 18px;
                        height: 18px;
                        background-position: 0 0;
                        background-repeat: no-repeat;
                        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjEzcHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDEzIDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+QkQ3OTdFNUQtQUY2NC00MTZELUE5RDItQ0QwMzRFODhGREE4QDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fcGxhaW5fb3Blbl9mb3JtdWxhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI1NC4wMDAwMDAsIC0yMjEuMDAwMDAwKSIgZmlsbD0iIzAyREZCMCIgc3Ryb2tlPSIjNjA4OUU3Ij4NCiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMjYxLjYxMDY2LDIzNy4wNDU5OTggQzEyNjEuNjA2MTMsMjM3LjA0MTU5MyAxMjYxLjYwMzg3LDIzNy4wMzkzNTUgMTI2MS41OTYxOSwyMzcuMDMxNzI4IEwxMjU1LjkzOTM0LDIzMS4zNzQ4NzQgQzEyNTUuMzUzNTUsMjMwLjc4OTA4NyAxMjU1LjM1MzU1LDIyOS44MzkzNCAxMjU1LjkzOTM0LDIyOS4yNTM1NTMgQzEyNTYuNTI1MTMsMjI4LjY2Nzc2NyAxMjU3LjQ3NDg3LDIyOC42Njc3NjcgMTI1OC4wNjA2NiwyMjkuMjUzNTUzIEwxMjYxLjE4NTc5LDIzMi4zNzg2OCBMMTI2MS4xODU3OSwyMjIgQzEyNjEuMTg1NzksMjIxLjE3MTU3MyAxMjYxLjg1NzM2LDIyMC41IDEyNjIuNjg1NzksMjIwLjUgQzEyNjMuNTE0MjEsMjIwLjUgMTI2NC4xODU3OSwyMjEuMTcxNTczIDEyNjQuMTg1NzksMjIyIEwxMjY0LjE4NTc5LDIzNiBDMTI2NC4xODU3OSwyMzYuODI4NDI3IDEyNjMuNTE0MjEsMjM3LjUgMTI2Mi42ODU3OSwyMzcuNSBDMTI2Mi4yNzU2NywyMzcuNSAxMjYxLjg5MDgyLDIzNy4zMzM5MzUgMTI2MS42MTA2NiwyMzcuMDQ1OTk4IFogTTEyNjEuMTg1NzksMjMyLjM3ODY4IEwxMjYyLjAzOTM0LDIzMy4yMzIyMzMgTDEyNjEuMTg1NzksMjMzLjU4NTc4NiBMMTI2MS4xODU3OSwyMzIuMzc4NjggWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjU5Ljg0Mjg5MywgMjI5LjAwMDAwMCkgcm90YXRlKDIwLjAwMDAwMCkgdHJhbnNsYXRlKC0xMjU5Ljg0Mjg5MywgLTIyOS4wMDAwMDApICI+PC9wYXRoPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+');
                    }
                }

                &__edit-name {

                    cursor: pointer;
                    margin-left: 10px;

                    &-icon {
                        width: 12px;
                        height: 16px;
                        background-position: 0 0;
                        background-repeat: no-repeat;
                        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDEyIDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+OTFEM0FFQ0UtMjU4RS00N0JBLUI1NEQtNUE5N0I5MURGNTkwQDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fcGxhaW5fb3Blbl9mb3JtdWxhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjIuMDAwMDAwLCAtMTIuMDAwMDAwKSIgZmlsbD0iIzAyREZCMCIgc3Ryb2tlPSIjNjA4OUU3Ij4NCiAgICAgICAgICAgIDxnIGlkPSJtZW51X3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDAwMDAwLCA5LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJ0YWJfb3BlbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuMDAwMDAwLCAyLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iaWNvbi9wZW4iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuNSwxMS41IEw5LjUsMTEuNSBMOS41LDIgQzkuNSwxLjE3MTU3Mjg4IDguODI4NDI3MTIsMC41IDgsMC41IEw3LDAuNSBDNi4xNzE1NzI4OCwwLjUgNS41LDEuMTcxNTcyODggNS41LDIgTDUuNSwxMS41IFogTTkuMzEwMzk3OTYsMTMuNSBMNS42ODk2MDIwNCwxMy41IEM2LjM3OTMxNzk1LDE1LjUxMDg0OSA3LjA0MDIwMzMsMTYuNSA3LjUsMTYuNSBDNy45NTk3OTY3LDE2LjUgOC42MjA2ODIwNSwxNS41MTA4NDkgOS4zMTAzOTc5NiwxMy41IFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNTAwMDAwLCA4LjUwMDAwMCkgcm90YXRlKDM1LjAwMDAwMCkgdHJhbnNsYXRlKC03LjUwMDAwMCwgLTguNTAwMDAwKSAiPjwvcGF0aD4NCiAgICAgICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
                    }
                }


                &__delete-board {
                    border-right: 1px solid $primary-color;
                }

            }

            &-add-board {
                display: flex;
                align-items: center;
                width: 30px;
                justify-content: center;
                margin-left: 7px;

                &-icon {
                    width: 15px;
                    height: 16px;
                    background-size: contain;
                    background-position: 0 0;
                    background-repeat: no-repeat;
                    background-image: url('data:image/svg+xml;base64,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');
                }
            }

            &-import {
                display: flex;
                align-items: center;
                justify-content: center;

                ::v-deep input {
                    margin-right: 10px;
                }
            }
        }
    }

    .disabled {
        pointer-events: none;
    }
</style>
